import { message } from 'antd';

import { updateItemDescription } from '../../../HttpRequests/itemDescriptions';
import handleException from '../../../Core/Helpers/handleException';

export default (data) => async () => {
  
  try {

    await updateItemDescription({ id: data.id, data });
    
    message.success("Item Description Updated");

    return true;

  } catch (error) {
    
    handleException(error);

    return false;

  }
}